import { normalizeConfigKey } from "./productConfigFormat";

/**
 * Humanize a config key into a display label.
 * Special-cases the common jewelry attribute keys, otherwise splits
 * camelCase / snake_case and title-cases the result.
 */
export const prettyLabel = (key: string): string => {
  if (!key) return "";
  switch (normalizeConfigKey(key)) {
    case "metal":
    case "metaltype":
      return "Metal Type";
    case "diamond":
    case "diamondquality":
      return "Diamond Quality";
    case "caratweight":
      return "Carat Weight";
    default:
      return key
        .replace(/([a-z])([A-Z])/g, "$1 $2")
        .replace(/_/g, " ")
        .replace(/\b\w/g, (l) => l.toUpperCase());
  }
};
